import { createContext, useContext } from "react";

// Tracks whether the route planner overlay is open. Lifted to Main so the
// first-visit hint and the map can both open/close it.
export const RoutePlannerContext = createContext({
    isOpen: false,
    open: () => {},
    close: () => {},
});

export const useRoutePlanner = () => useContext(RoutePlannerContext);
